function $b0da835bcdc0db5f$export$855bbfca54f168b2(cont) {
    var left = $('<div class="navbar-start d-flex flex-row align-items-center"></div>').appendTo(cont);
    $('<div class="toggle-btn"><span></span><span></span><span></span></div>').appendTo(left);
    $('.toggle-btn').on(click, function(evt) {
        evt.stopPropagation();
        $('body').toggleClass('show');
    });
    $('html').on(click, function(evt) {
        if ($(evt.target).closest('.sidebar ul li a[data-bs-toggle="collapse"]').length == 0) $('body').removeClass('show');
    });
    var ul = $('<ul id="headerLeftButtons" class="navbar-nav me-2 left--btns"></ul>').appendTo(left);
    tableButton(ul, {
        object: 'customer',
        objectSub: 'client',
        tip: parameter.customer.label
    });
    tableButton(ul, {
        object: 'calendar',
        objectSub: user.calendarDefault ? user.calendarDefault : 'calendarPersonal',
        badge: {
            objectSub: 'calendarToday'
        },
        tip: parameter.calendar.label
    });
    tableButton(ul, {
        object: 'mailStat',
        objectSub: 'inbox',
        badge: {
            objectSub: 'unseen'
        }
    });
    tableButton(ul, {
        object: 'followup',
        objectSub: 'taskToday',
        badge: {
            objectSub: 'taskToday'
        },
        tip: parameter.followup.label
    });
    tableButton(ul, {
        object: 'document'
    });
    ul.children().each(function() {
        $(this).wrap('<li class="nav-item"></li>');
    });
    if (test && admin) {
        var debugInfo = getLocalFlag('debug-info');
        if (debugInfo) $(document.body).addClass('debug-info');
        buildFormLine(left, {
            field: 'checkbox',
            value: debugInfo,
            save: function(val) {
                if (val) $(document.body).addClass('debug-info');
                else $(document.body).removeClass('debug-info');
                toggleLocalFlag('debug-info');
            }
        });
    }
    $('<i id="loading" class="icon fa-regular fa-spinner fa-spin fa-fw fa-lg d-none" aria-hidden="true"></i>').appendTo(left);
}


function $8f35f1e96f886354$export$a63ced91f3a681c9(cont, key, icon, tooltip, callback) {
    var value = getLocalFlag(key);
    var button = $('<a id="' + key + 'Btn" class="nav-link link-secondary"><i class="icon fa-regular fa-' + icon + ' fa-fw fa-lg"></i></a>').appendTo(cont).addTooltip(tooltip).on(click, function() {
        value = !value;
        setLocalFlag(key, value);
        button.toggleClass('border border-1 border-secondary');
        if (callback) callback(value);
    });
    if (value) {
        button.toggleClass('border border-1 border-secondary');
        if (callback) callback(value);
    }
}


function $91985247f90970e5$export$7306cd81b5b921c(cont) {
    var right = $('<div class="navbar-end d-flex flex-row align-items-center"></div>').appendTo(cont);
    buildGlobalSearch(right);
    var ul = $('<ul id="headerRightButtons" class="navbar-nav me-2"></ul>').appendTo(right);
    var pm = {
        object: 'notification',
        badge: {
            objectSub: 'unseen'
        }
    };
    if (!user.admin) pm = Object.assign(pm, {
        popup: {
            title: 'title',
            content: 'message'
        },
        open: {
            system: 1
        }
    });
    tableButton(ul, pm);
    // if (user.admin) tableButton(ul, {object: 'guide', badge: {objectSub: 'unseen'}});
    $('<a id="tabBtn" class="nav-link link-secondary"><i class="icon fa-regular fa-question-circle fa-lg fa-fw"></i></a>').appendTo(ul).addTooltip(parameter.wiki.label).on(click, function() {
        buildHelp();
    });
    tableButton(ul, {
        object: 'tracking',
        badge: {
            objectSub: 'trackingToday'
        }
    });
    if (test) $('<a id="tabBtn" class="nav-link link-secondary"><i class="icon fa-regular fa-tv-retro fa-lg fa-fw"></i></a>').appendTo(ul).addTooltip('Livesystem').on(click, function() {
        window.open('https://' + client + '.' + domain);
    });
    $('<a id="tabBtn" class="nav-link link-secondary"><i class="icon fa-regular fa-window-restore fa-lg fa-fw"></i></a>').appendTo(ul).addTooltip('Zweiter Tab').on(click, function() {
        window.open(document.location);
    });
    $('<a id="refreshBtn" class="nav-link link-secondary"><i id="fullIcon" class="icon fa-regular fa-redo fa-lg fa-fw"></i></a>').appendTo(ul).addTooltip('Aktualisieren [F5]').on(click, function() {
        noLogoutInfo = true;
        reload();
    });
    (0, $8f35f1e96f886354$export$a63ced91f3a681c9)(ul, 'chat', 'comment', 'Chat', function(value) {
        if (value) ajax({
            object: 'chat',
            callback: buildChat
        });
        else $('#chat').remove();
    });
    ul.children().each(function() {
        $(this).wrap('<li class="nav-item"></li>');
    });
    // profile
    var cont1 = $('<div class="dropdown ms-sm-2"></div>').appendTo(right);
    var cont2 = $('<a class="d-flex link-secondary text-decoration-none dropdown-toggle" href="javascript:void(0)" data-bs-toggle="dropdown" aria-expanded="false">').appendTo(cont1);
    var cont3 = $('<div class="avatar avatar-md"></div>').appendTo(cont2);
    var src;
    if (user.avatar && user.avatar.length > 50) src = user.avatar;
    else if (user.pic) src = getObjectValue(data, [
        'document',
        user.pic,
        'file'
    ]);
    if (src) $('<img class="img-fluid rounded-circle" src="' + src + '">').appendTo(cont3);
    else {
        if (user.acronym == 'upp') user.acronym = '';
        $('<span class="avatar-title rounded-circle">' + user.acronym + '</span>').appendTo(cont3);
    }
    if (dropdowns) buildDropdown(cont1, dropdowns.profile, null, true);
    cont3.val = function(val) {
        cont3.empty();
        $('<img class="img-fluid rounded-circle" src="' + val + '">').appendTo(cont3);
    };
    register(cont3, 'user', user.id, 'avatar');
    // build setup bar
    if (user.setupUser && store.setup < 100 && !test && getScreenWidth() >= 1920) {
        var element = buildField(right, {
            object: 'store',
            row: store
        }, 'setup', fields.store.setup).prependTo(right);
        element.addTooltip('Fortschritt Einrichtung');
        element.click(function() {
            ajax({
                type: 'detail',
                object: 'store',
                id: store.id,
                send: {
                    update: true
                },
                noOverview: true
            });
        });
    }
    if (test && user.admin) buildConfigSwitch(right).prependTo(right);
}


// eslint-disable-next-line no-redeclare,no-unused-vars
function $eeb9eadd40b8d421$var$buildHeader() {
    var cont1 = $('<header class="navbar navbar-expand bg-white"></header>').prependTo(document.body);
    var cont2 = $('<div class="container-fluid"></div>').appendTo(cont1);
    $(`<a href="/" id="logo" class="navbar-brand"><img src="${window.fileUrls.favicon}" width="32" height="32" class="img-fluid d-lg-none"><img src="${window.fileUrls.logo}" width="162" height="32" class="img-fluid d-none d-lg-block"></a>`).appendTo(cont2);
    var cont3 = $('<div class="collapse navbar-collapse justify-content-between"></div>').appendTo(cont2);
    (0, $b0da835bcdc0db5f$export$855bbfca54f168b2)(cont3);
    (0, $91985247f90970e5$export$7306cd81b5b921c)(cont3);
    return cont1;
}
window.buildHeader = $eeb9eadd40b8d421$var$buildHeader;


//# sourceMappingURL=index.8742d74e.js.map
